(function () {
  var savedBox = null;
  var savedOrigin = null;

  function moveDeliveryBox() {
    var box = savedBox || document.querySelector('.delivery_box');
    var slot = document.getElementById('js-delivery-box-slot');
    if (!box || !slot || slot.contains(box)) return;

    if (!savedBox) {
      savedBox = box;
      savedOrigin = box.parentElement;
    }

    slot.appendChild(box);

    if (savedOrigin && savedOrigin !== slot) {
      savedOrigin.classList.add('delivery-box-origin--hidden');
    }
  }

  // Re-insert after cart AJAX updates (AjaxCartSubtotal innerHTML replacement)
  function observeSubtotal() {
    var subtotal = document.getElementById('AjaxCartSubtotal');
    if (!subtotal) return;
    new MutationObserver(function () {
      if (savedBox) moveDeliveryBox();
    }).observe(subtotal, { childList: true });
  }

  // Handle async app injection (delivery_box may not exist yet on DOMContentLoaded)
  function initOrObserve() {
    if (document.querySelector('.delivery_box')) {
      moveDeliveryBox();
    } else {
      var observer = new MutationObserver(function () {
        if (document.querySelector('.delivery_box')) {
          moveDeliveryBox();
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    observeSubtotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrObserve);
  } else {
    initOrObserve();
  }
})();
